import React from 'react';
import { toast } from 'react-toastify';
import { notify } from '../App';
import Helper from './Helper';

class ProductAmountUpdate extends React.Component {
    handleUpdateAmount = (amount, maxStock, e)=>{
        e.preventDefault();
        amount = isNaN(amount)||!amount || parseInt(amount) < 1 ? 1 : parseInt(amount);
        amount = amount >99?99:amount;
        if(amount > maxStock){
            amount = maxStock;
            notify("warning", "Xin lỗi, đã đạt đến giới hạn đặt hàng!");
        }
        this.props.handleUpdateAmount(amount);
    }
    render(){
        let {productAmount, info} = this.props;
        productAmount = parseInt(productAmount);
        let instock = info.in_stock;
        let orderLimit = info.order_limit > 0 ? info.order_limit : 1000;
        let outstock = info.sold;
        if(info.event_name){
            instock = info.event_in_stock;
            outstock = info.event_out_stock;
        }
        let maxStock = Math.min(orderLimit, (instock ? instock - outstock:99));
        return (
            <div className="product-view-quantity-box-block">
                <a href="/"  onClick={(e)=>this.handleUpdateAmount(productAmount-1,maxStock, e)} className="btn-subtract-qty">
                    <span style={{ color: '#9FA7AB' }}><i className='fas fa-minus' /></span>
                </a>
                <input onChange={(e)=>this.handleUpdateAmount(e.target.value,maxStock,e)} 
                type="text" name="qty" id="qty"  maxvalue="99" value={productAmount} 
                    title="SL" className="input-text qty" />
                <a href="/" className="btn-add-qty"  onClick={(e)=>this.handleUpdateAmount(productAmount+1, maxStock, e)}>
                <span style={{ color: '#9FA7AB' }}><i className='fas fa-plus' /></span>
                </a>
            </div>
        )
    }
}
export default ProductAmountUpdate;